import { NumberUtils } from './number.utils';

export class ComparatorUtils {
  public static generateComparatorForObject() {
    return (a, b) =>
      JSON.stringify(a).split('').sort().join('') ===
      JSON.stringify(b).split('').sort().join('');
  }

  public static generateComparatorForDecimal() {
    return (a: number, b: number) => NumberUtils.isSameDecimalNumber(a, b);
  }
}
